import { Button, Card, Grid, Heading, Layout } from '@design-systems/canvas-ui'
import { PageLayout } from '@plm-core/utils'
import { USER_LOGIN_STATE_KEY } from 'App/authComponents/userLoginCache'
import { LogoSlot } from 'App/LogoSlot'
import { LOGIN_FAILED_TRACE_PARAM } from 'App/authComponents/authConfig'

const LoginFailedPage = () => {
  const traceId = new URLSearchParams(window.location.search).get(
    LOGIN_FAILED_TRACE_PARAM,
  )

  const handleTryAgain = () => {
    localStorage.removeItem(USER_LOGIN_STATE_KEY)
    window.location.href = '/'
  }

  return (
    <Layout>
      <Layout.GlobalHeader logoSlot={<LogoSlot />} />
      <Layout.Body>
        <PageLayout>
          <Grid.Container direction="column">
            <Grid.Item size={{ xs: 12 }}>
              <Heading size={1}>Unable to log in</Heading>
            </Grid.Item>
            <Grid.Item size={{ xs: 12 }}>
              <Card className="hc8-pa-4x">
                <Grid.Container align="center">
                  <Grid.Item size={{ xs: 12 }}>
                    <p>
                      We couldn't log you in to PLM. Please try again.{' '}
                      {traceId && (
                        <>
                          If the issue continues, contact support and provide
                          the request ID below.
                        </>
                      )}
                    </p>
                  </Grid.Item>
                  {traceId && (
                    <>
                      <Grid.Item>
                        <strong>{traceId}</strong>
                      </Grid.Item>
                      <Grid.Item>
                        <Button
                          variant="ghost"
                          onClick={() => navigator.clipboard.writeText(traceId)}
                        >
                          Copy
                        </Button>
                      </Grid.Item>
                    </>
                  )}
                  <Grid.Item size={{ xs: 12 }}>
                    <Button variant="primary" onClick={handleTryAgain}>
                      Try again
                    </Button>
                  </Grid.Item>
                </Grid.Container>
              </Card>
            </Grid.Item>
          </Grid.Container>
        </PageLayout>
      </Layout.Body>
    </Layout>
  )
}

export default LoginFailedPage
